/**
 * `core/wordpress/mwwpform/recaptcha.js`
 * - Google reCAPTCHA の処理
 *
 * 使用方法:
 * - import {initReCAPTCHA, loadReCaptcha} from "../mwwpform/index.js";
 */


import {config} from "../../../config.js";
import {barbaEventObserver} from "../../barba/utils/barbaEventObserver.js";


/**
 * initReCAPTCHA
 * - Google reCAPTCHAの初期化
 * - デフォルトの仕様: 2分制限 の解除
 */
export function initReCAPTCHA() {
  console.log("🔑 Initializing reCAPTCHA...");

  const mwWpFormSubmit = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]');
  if (!mwWpFormSubmit) return;

  mwWpFormSubmit.addEventListener('click', sendReCAPTCHA);
  barbaEventObserver.observeEvents([[mwWpFormSubmit, 'click', sendReCAPTCHA]]);
}


/**
 * sendReCAPTCHA
 * - reCAPTCHA の送信処理
 * - initReCAPTCHAで実行
 *
 * トークンは発行から2分で失効する。ページ読み込み時に1度だけ取る作りだと、
 * 入力に2分以上かけた人がサーバー側の検証で弾かれる。送信の直前に取り直して
 * hidden の recaptcha-v3 に入れることで、常に発行直後のトークンを送る。
 *
 * ここで ajax 検証（admin-ajax.php の verify_recaptcha）はしない。
 * siteverify はトークンを1度しか受け付けないため、先に ajax で消費すると
 * サーバー側の本検証が必ず失敗する。検証はサーバー側の1回だけに寄せる。
 */
function sendReCAPTCHA(e) {
  e.preventDefault();
  const form = document.querySelector('.mw_wp_form > form');
  const submitBtn = document.querySelector('.mw_wp_form [type="submit"][name="submitConfirm"]');
  const tokenField = document.querySelector('.mw_wp_form input[name="recaptcha-v3"]');
  if (!form) return;
  submitBtn.disabled = true;

  const submitForm = () => {
    // form.submit() では押したボタンの name/value が送られないので補う
    const hiddenField = document.createElement("input");
    hiddenField.type = "hidden";
    hiddenField.name = "submitConfirm";
    hiddenField.value = submitBtn.value || "確認画面へ";
    form.appendChild(hiddenField);
    form.submit();
  };

  // reCAPTCHA が読み込めていない場合でも送信自体は止めない（サーバー側で弾かれる）
  if (typeof grecaptcha === "undefined") {
    submitForm();
    return;
  }

  grecaptcha.ready(() => {  // eslint-disable-line no-undef
    grecaptcha.execute(config.recaptchaPublicKey, {action: "submit"})  // eslint-disable-line no-undef
      .then((token) => {
        if (tokenField) tokenField.value = token;
        submitForm();
      })
      .catch((err) => {
        console.error("reCAPTCHA error:", err);
        submitBtn.disabled = false;
      });
  });
}


/**
 * loadReCaptcha
 * Google reCAPTCHAスクリプトの動的読み込み
 **/
export function loadReCaptcha() {
  const siteKey = config.recaptchaPublicKey;
  if (document.getElementById("recaptcha-script-js")) return;

  const script = document.createElement("script");
  script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
  script.id = "recaptcha-script-js";
  document.body.appendChild(script);

  /*
    // initReCAPTCHAで代用できるので削除
    script.onload = () => {
      grecaptcha.ready(() => {  // eslint-disable-line no-undef
        grecaptcha.execute(siteKey, {action: "homepage"}).then((token) => {  // eslint-disable-line no-undef
          const recaptchaResponse = document.querySelector('input[name="recaptcha-v3"]');
          if (recaptchaResponse) recaptchaResponse.value = token;
        });
      });
    };
  */
}